import { Outlet, Navigate } from 'react-router-dom'
import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const PrivateRoutes = () => {
    const [token, setToken] = useState(() => localStorage.getItem('token'));
    
    useEffect(() => {
        const fetchedToken = localStorage.getItem('token');

        if (fetchedToken !== token) {
            setToken(fetchedToken);
        }
    }, [token]);

    if (!token) {
        toast.error('You are not authenticated. Please log in.');
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}

export default PrivateRoutes;
